import axios from "axios";
import constants from "@/constants.js";
import {getJwt, isAuthenticated} from "@/util/authenticator.js";
import {broadcast} from "@/util/eventHandler";

export const communicator = axios.create({
    baseURL: constants.API_URL,
    timeout: 60000
});

communicator.interceptors.request.use(function (config) {
    config.headers.locale = "de";
    if(isAuthenticated()) {
        config.headers.Authorization = "Bearer " + getJwt();
    }
    return config;
});

communicator.interceptors.response.use(null, function (error) {
    if(error.response.status === 403) {
        broadcast("forbidden");
        return error;
    }
    throw error;
});
